module.exports = __webpack_public_path__ + "img/loading.08cfe374.gif";